import {Configuration} from "@api-clients/runtime";
import {ProveCampaign} from "@api-clients/prove/schema/ProveCampaign";
import {ProveLineItem} from "@api-clients/prove/schema/ProveLineItem";

export class SaveProveLineItemTagApi {

    static async execute(
        configuration: Configuration,
        campaign: ProveCampaign,
        lineItem: ProveLineItem,
        tag: string
    ): Promise<ProveLineItem> {
        const response = await fetch(`${configuration.basePath}/a360/v1/prove/campaigns/${campaign.id}/insertion-orders/${campaign.insertionOrder!.id}/line-items/${lineItem.id}/tag`, {
            method: 'PUT',
            headers: configuration.headers,
            body: JSON.stringify({
                value: tag
            })
        });

        return response.json();
    }

}
